module.exports = __webpack_public_path__ + "static/media/photo5.5b8bcc23.jpg";